/** Warm the Location Map chunk so the first click is not 3–4s of Vite/Suspense. */
export function prefetchLocationMap(): void {
  void import("./LocationMap");
}
